<template>
  <div class="meet-controls-wrapper">
    <div class="meet-info">
          <div class="state">
            <el-tooltip class="item" effect="dark" :content="$store.state.state" placement="top">
              <div class="icon" :class="$store.state.state" />
            </el-tooltip>
          </div>
      <span class="time">{{ room.title }}</span>
      <span class="meet-subject"></span>
    </div>

    <div class="meet-items">
    <el-tooltip class="item"  effect="dark" :content="$t('meetControls.toggleMic')" placement="top">
      <div class="control-item" :class="micState != 'on' ? 'off' : ''" @click="toggleMic">
        <i class="fas fa-microphone" v-if="micState == 'on'"></i>
        <i class="fas fa-microphone-slash" v-if="micState != 'on'"></i>
      </div>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" :content="$t('meetControls.toggleCam')" placement="top">
      <div class="control-item" :class="webcamState != 'on' ? 'off' : ''" @click="toggleWebcam">
        <i class="fas fa-video" v-if="webcamState == 'on'"></i>
        <i class="fas fa-video-slash" v-if="webcamState != 'on'"></i>
        </div>
    </el-tooltip>

    <el-dropdown>
      <div class="control-item screen-share-item">
        <span class="el-dropdown-link">
          <i class="fas fa-desktop"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="toggleShare('presentation')"><i class="far fa-file-powerpoint"></i>{{ $t('meetControls.sharePresentation') }}</el-dropdown-item>
          <el-dropdown-item @click.native="toggleShare('video')"><i class="far fa-file-video"></i>{{ $t('meetControls.shareVideo') }}</el-dropdown-item>
        </el-dropdown-menu>
      </div>
    </el-dropdown>

    <el-tooltip class="item social-deck-item" effect="dark" :content="$t('meetControls.toggleSocialHub')" placement="top">
      <div class="control-item" @click="$root.$emit('toggleMenu')">
        <i class="far fa-comment-dots"></i>
      </div>
    </el-tooltip>

    <el-tooltip class="item" effect="dark" :content="$t('meetControls.inviteSomeone')" placement="top" v-if="roomType == 'networking'">
      <div class="control-item" @click="$store.state.addPerson = true">
        <i class="fas fa-user-plus"></i>
      </div>
    </el-tooltip>

    <el-tooltip class="item" effect="dark" :content="$t('meetControls.openSettings')" placement="top">
      <div class="control-item" @click="openSettingsModal">
        <i class="fas fa-cog"></i>
      </div>
    </el-tooltip>

    </div>

    <div class="meet-leave">
      <el-popconfirm
        :confirm-button-text="$t('meetControls.confirmLeave')"
        :cancel-button-text="$t('meetControls.cancelLeave')"
        @confirm="leaveMeet"
        icon="el-icon-info"
        icon-color="red"
        :title="$t('meetControls.leaveRoomSureMsg')"
      >
        <el-button type="danger" slot="reference">{{ $t('meetControls.leaveRoom') }}</el-button>
      </el-popconfirm>
    </div>
  </div>
</template>

<script>


import UrlParse from "url-parse";

export default {
  name: "MeetControlsComponent",
  props: {
    roomClient: {
      type: Object,
      required: true
    },
    roomType: null ,
  },
  data(){
    return {

    }
  },
  methods: {
    leaveMeet() {
      if(this.roomType == 'session')
      {
       this.$router.push({ name:"livestreams"});
      }
      else{
        this.$router.push({ name:"networking"});
      }
    },
    toggleShowMessagePanel() {
      this.$store.state.showMessagePanel = !this.$store.state.showMessagePanel;
    },
    openSettingsModal() {
      this.$store.state.settingsModal = true;
    },
    toggleShare(shareMode) {
      if (this.shareState === "on") {
        this.$store.state.shareMode = null;
        this.roomClient.disableShare();
      } else {
        this.$store.state.shareMode = shareMode;
        this.roomClient.enableShare();
      }
    },
    toggleWebcam() {
      if (this.webcamState === "on") {
        this.roomClient.disableWebcam();
      } else {
        this.roomClient.enableWebcam();
      }
    },
    toggleMic() {
      this.micState === "on"
        ? this.roomClient.muteMic()
        : this.roomClient.unmuteMic();
    }
  },
  computed: {
    room() {
      var room = {
        title: 'Test'
      };

      if(this.roomType == 'networking')
      {
        room.title = this.currentNetworkingRoom.title;
      }
      else if(this.roomType == 'session')
      {
        room.title = this.currentSession.title;
      }

      return room;
    },
    currentSession() {
      return this.$store.getters.getCurrentSession;
    },
    currentNetworkingRoom() {
      return this.$store.getters.getCurrentRoom;
    },
    producers() {
      return this.$store.state.producers;
    },
    audioProducer() {
      return this.producers.find(producer => producer.track.kind === "audio");
    },
    videoProducer() {
      return this.producers.find(
        producer => producer.track.kind === "video" && producer.type !== "share"
      );
    },
    shareProducer() {
      return this.producers.find(producer => producer.type === "share");
    },
    me() {
      return this.$store.state.me;
    },
    webcamState() {
      let webcamState;

      if (!this.me.canSendWebcam) {
        webcamState = "unsupported";
      } else if (this.videoProducer && this.videoProducer.type !== "share") {
        webcamState = "on";
      } else {
        webcamState = "off";
      }

      return webcamState;
    },
    micState() {
      let micState;

      if (!this.me.canSendMic) {
        micState = "unsupported";
      } else if (!this.audioProducer) {
        micState = "unsupported";
      } else if (!this.audioProducer.paused) {
        micState = "on";
      } else {
        micState = "off";
      }

      return micState;
    },

  }
  };
</script>




// WEBPACK FOOTER //
// src/components/media/MeetControlsComponent.vue